import type {
  TGetInitialDataResponse,
  TSignInParams,
} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import type {TFormError} from '@kapitalist/contract/types'
import {PostApi} from '~/api/client'
import globalDataMock from '~/api/endpoints/GetInitialData/mock'
import MockConfig from '~/api/mocks/config'

export type TSignInResponse = TGetInitialDataResponse

const endpoint = endpoints.auth.signin

/**
 * On successful login, this returns GetInitialData
 */
export default class SignIn extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected mockRequestFailure(params: TSignInParams): TFormError | null {
    if (params.password === 'failfailfail') {
      return {errors: {password: [`That password isn't right.`]}}
    }

    // return super.mockRequestFailure(params, pathPieces)
    return null // TODO replace this with defaultMockRequestFailure if/once we bring that behavior in from MW
  }

  protected getMockResponse(): TSignInResponse {
    MockConfig.loggedOut = false

    return globalDataMock
  }

  protected transformResponse(r: TSignInResponse) {
    return r
  }
}
